import handler from 'api/handler'

const prefix = '/public/blog'

const methods = {
    fetchNews: args => handler({ method: 'get', url: prefix + '/fetch', args }),
    updateNews: args => handler({ method: 'post', url: prefix + '/update', args }),
    likeBlog: args => handler({ method: 'post', url: prefix + '/like', args }),
    commentOnBlog: args => handler({ method: 'post', url:prefix +  '/comment', args }),
    shareBlog: args => handler({ method: 'post', url: prefix + '/share', args }), 
}

export default methods